import { useLayoutEffect } from "react";
import styled from "styled-components";
import Footer from "../../components/fragments/Footer";
import NavBar from "../../components/fragments/NavBar";
import HeroBanner from "../../components/fragments/HeroBanner";

import { Container } from "../../components/styles/Layout";
import { Button } from "../../components/styles/Button";

import { useStaticSeo } from "../../hooks/useSeo";
import { STATIC_SEO } from "../../data/seo";

const Wrapper = styled.section`
    margin-bottom: 4rem;
`;
const TinyTitle = styled.h4``;
const Text = styled.p`
    max-width: 40rem;
`;

const CertificateBlock = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 1.5rem;
    align-items: flex-start;
    margin-bottom: 2rem;
`;
const CertificateFrame = styled.a`
    display: block;
    flex: none;
    width: 14rem;
    border: 1px solid #e6e6e6;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12);
    transition: 0.3s;
    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.16);
        transition: 0.3s;
    }
`;
const CertificateImg = styled.img`
    display: block;
    width: 100%;
    height: auto;
`;
const CertificateSide = styled.div`
    flex: 1 1 16rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 0.8rem;
`;
const DownloadButton = styled(Button)`
    width: fit-content;
`;

/**
 * FooterNav's "Client Money Protection Certificate" link used to point
 * straight at the PDF. It now points here instead - the PDF itself is
 * untouched at the same URL, just no longer the first thing a visitor hits.
 */
export default function ClientMoneyProtection() {
    useStaticSeo(STATIC_SEO["/client-money-protection"]);
    useLayoutEffect(() => {
        document.getElementById("root").scrollTo(0, 0);
    }, []);

    return (
        <>
            <NavBar location="public" pageTitle="Client Money Protection" />
            <HeroBanner
                title="Client Money Protection"
                background="/images/pp-outside-dark.jpg"
                showRating={false}
            />
            <Wrapper>
                <Container>
                    <CertificateBlock>
                        <CertificateFrame
                            href="/legal/Propertymark_CMP_Main_Scheme_Certificate.pdf"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <CertificateImg
                                src="/images/legal/cmp-certificate.jpg"
                                alt="Property People's Propertymark Client Money Protection certificate, valid to 31 May 2027"
                            />
                        </CertificateFrame>
                        <CertificateSide>
                            <Text>
                                Our current Client Money Protection certificate, issued by
                                Propertymark and valid to 31 May 2027.
                            </Text>
                            <a
                                href="/legal/Propertymark_CMP_Main_Scheme_Certificate.pdf"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <DownloadButton bright type="button">
                                    Download this as a pdf file
                                </DownloadButton>
                            </a>
                        </CertificateSide>
                    </CertificateBlock>

                    <TinyTitle>Client Money Protection (CMP)</TinyTitle>
                    <Text>
                        With us your money is protected in a segregated client money account
                        that gets audited once a year as we are members of Propertymark
                        regulatory body.
                    </Text>
                    <Text>
                        Client Money Protection is a scheme that reimburses landlords and
                        tenants should a letting agent misappropriate their rent, deposit or
                        other client funds. It is a legal requirement for letting agents in
                        England, Scotland and Wales.
                    </Text>
                    <Text>
                        Client Money Protection (CMP) is required for all Propertymark-regulated
                        companies that handle client money or use a third party to manage
                        client money on their behalf and that's us.
                    </Text>
                    <Text>
                        Every year before being approved for annual Propertymark CMP, we have
                        to provide audit of client money account, evidence of our registration
                        with an Property Ombudsman, the Information Commissioner's Office (ICO)
                        and, Anti-Money Laundering (AML) supervisory body: HM Revenue &amp;
                        Customs (HMRC).
                    </Text>
                </Container>
            </Wrapper>
            <Footer />
        </>
    );
}
